import React, { useEffect, useRef, useState } from 'react';
import useScroll from '../Hooks/useScroll';

const StickyCta = (props) => {
  const ref = useRef();
  const scrollY = useScroll();
  const [parentElement, setParentElement] = useState();
  const [isSticky, setIsSticky] = useState(true);
  useEffect(() => {
    if (!parentElement) return;
    const parentElemPosition = parentElement.getBoundingClientRect();
    const elemPosition = ref.current.getBoundingClientRect();
    const hasScrolledPastElem =
      scrollY == 0
        ? false
        : parentElemPosition.bottom +
            elemPosition.height -
            (window.innerHeight + elemPosition.height) <=
          0;
    setIsSticky(!hasScrolledPastElem);
  }, [scrollY, parentElement]);

  useEffect(() => {
    if (!ref?.current) return;
    setParentElement(ref.current.parentElement);
    const elemPosition = ref.current.getBoundingClientRect();
    ref.current.parentElement.style.height = elemPosition.height + 'px';
  }, [ref]);
  return (
    <div
      ref={ref}
      className={isSticky ? 'sticky-cta' : 'scrolledPast sticky-cta'}
    >
      {props.children}
    </div>
  );
};

export default StickyCta;
